import WarningIcon from "@/components/icons/warningIcon";
import React from "react";

const DevIndicator: React.FC = () => {
  return (
    <div className="fixed top-0 left-0 z-[100] bg-yellow-200 text-yellow-700 w-full h-10 text-center font-semibold flex gap-2 items-center justify-center px-4">
      <div>
        <WarningIcon width={18} height={18} />
      </div>{" "}
      Development Environment: Data and actions here are for testing purposes
      only
    </div>
  );
};

export default DevIndicator;
